import React, { useEffect, useState } from 'react';
import { useFontLoader } from '../../../../dummies/RichTextEditor/useFontLoader';
import { heritageColors } from '../../../../heritageTheme.ts';

const Spotlight = ({ data = { notices: [] }, title = 'לוח מודעות', showTitle = true }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visible, setVisible] = useState(true);
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 60_000);
    return () => clearInterval(id);
  }, []);

  const activeNotices = (data.notices || []).filter(
    n => !n.expiryDate || new Date(n.expiryDate) > now
  );

  const allNoticesHtml = activeNotices.map(n => n.content).join(' ') || '';
  useFontLoader(allNoticesHtml);

  // Auto-advance with fade
  useEffect(() => {
    if (activeNotices.length <= 1) return;
    const interval = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setCurrentIndex(i => (i + 1) % activeNotices.length);
        setVisible(true);
      }, 500);
    }, 5000);
    return () => clearInterval(interval);
  }, [activeNotices.length]);

  // Reset index if notices change
  useEffect(() => {
    setCurrentIndex(0);
    setVisible(true);
  }, [activeNotices.length]);

  const current = activeNotices[currentIndex] || null;

  return (
    <div style={{
      padding: '20px',
      direction: 'rtl',
      height: '100%',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      fontSize: 'inherit',
      boxSizing: 'border-box',
    }}>
      {showTitle && (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          borderBottom: `0.0625em solid ${heritageColors.border || '#D7CCC8'}`,
          paddingBottom: '8px',
          marginBottom: '12px',
        }}>
          <span className="material-symbols-outlined" style={{ color: heritageColors.navy || '#1a3a5c', fontSize: '1.1em' }}>campaign</span>
          <h3 style={{ margin: 0, fontWeight: 'bold', color: heritageColors.navy || '#1a3a5c', fontSize: '0.875em' }}>{title}</h3>
        </div>
      )}

      {activeNotices.length === 0 ? (
        <p style={{ color: heritageColors.slate || '#795548', fontSize: '0.875em' }}>אין מודעות להצגה</p>
      ) : (
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between', overflow: 'hidden' }}>
          {/* Notice content */}
          <div style={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '0.5em',
          }}>
            <div
              style={{
                opacity: visible ? 1 : 0,
                transition: 'opacity 0.5s ease',
                fontSize: '0.9em',
                color: heritageColors.navy || '#1a3a5c',
                lineHeight: 1.6,
                textAlign: 'center',
                width: '100%',
              }}
              dangerouslySetInnerHTML={{ __html: current?.content || '' }}
            />
          </div>

          {/* Indicators */}
          {activeNotices.length > 1 && (
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              gap: '6px',
              paddingTop: '8px',
              flexShrink: 0,
            }}>
              {activeNotices.map((_, i) => (
                <button
                  key={i}
                  onClick={() => { setVisible(false); setTimeout(() => { setCurrentIndex(i); setVisible(true); }, 300); }}
                  style={{
                    width: i === currentIndex ? '1.4em' : '0.5em',
                    height: '0.5em',
                    borderRadius: '0.25em',
                    border: 'none',
                    padding: 0,
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    backgroundColor: i === currentIndex
                      ? (heritageColors.gold || '#D4AF37')
                      : (heritageColors.border || '#D7CCC8'),
                  }}
                />
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Spotlight;
